<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
      <section id="ngx-datatable-kitchen-sink">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title"> {{ 'MENU.DASHBOARD.partners' | translate }} </h4>
            <!-- <button class="btn btn-primary" (click)="addCoupon()">
              Add Employees
            </button> -->
          </div>
          <div class="card-body">
            <p class="card-text"> {{ 'MENU.DASHBOARD.partners_list' | translate }}</p>
          </div>
        </div>
  
        <div class="row d-flex justify-content-between">
          <div class="col-md-2 col-sm-12 mb-1 mb-md-0">
            <div class="form-group">
              <label for="itemsPerPage"  style="margin-right: 23px !important">{{ 'MENU.DASHBOARD.show' | translate }}</label>
              <div class="d-flex align-items-center">
                <select
                  id="itemsPerPage"
                  class="form-control form-control-sm mr-2"
                  [(ngModel)]="itemsPerPage"
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <span>{{ 'MENU.DASHBOARD.entries' | translate }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="searchInput" class="mr-2">{{ 'MENU.DASHBOARD.search' | translate }}</label>
              <input
                id="searchInput"
                type="search"
                placeholder="{{ 'MENU.DASHBOARD.search' | translate }}"
                class="form-control form-control-sm"
                (keyup)="filterUpdate($event)"
                (search)="filterUpdate($event)"
              />
            </div> 
          </div>
        </div>
  
        <ngx-datatable 
        [rows]="partners"
        [rowHeight]="58"
        class="bootstrap core-bootstrap bg-white"
        [limit]="itemsPerPage"
        [columnMode]="ColumnMode.force"
        [headerHeight]="40"
        [footerHeight]="50"
        [scrollbarH]="true"
          [messages]="messages"

      >
        <ngx-datatable-column
          name="{{ 'MENU.DASHBOARD.id' | translate }}"
          prop="id"
          [width]="60"
        ></ngx-datatable-column>
        
       <ngx-datatable-column
          name="{{ 'MENU.DASHBOARD.partner_name' | translate }}"
          prop="name"
          [width]="200"
        >
          <ng-template ngx-datatable-cell-template let-row="row">
            {{ row.name  ? (row.name | slice:0:20) + '...' : '-' }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column
          name="{{ 'MENU.DASHBOARD.partner_logo' | translate }}"
          [width]="100"
        >
        <ng-template ngx-datatable-cell-template let-row="row">
            <div class="cell-line-height text-center">
              <img [src]="row.logo" alt="Ad Image" width="70" height="70" style="border-radius: 50%;"
                        (error)="onImageError($event)"
 />
            </div>
          </ng-template>
          <!-- <ng-template ngx-datatable-cell-template let-row="row">
            <div class="cell-line-height text-center">
              <img [src]="row.logo" alt="Ad Image" width="60" height="60" />
            </div>
          </ng-template> -->
        </ngx-datatable-column>

        
         <ngx-datatable-column
          name="{{ 'MENU.DASHBOARD.partner_description' | translate }}"
          prop="description"
          [width]="200"
        >
          <ng-template ngx-datatable-cell-template let-row="row">
            {{ (row.description | slice:0:30) + '...'}}
          </ng-template>
        </ngx-datatable-column>

      
        <ngx-datatable-column
          name="{{ 'MENU.DASHBOARD.partner_url' | translate }}"
          prop="url"
          [width]="200"
        >
          <ng-template ngx-datatable-cell-template let-row="row">
            <a [href]="row.url" target="_blank">{{ row.url }}</a>
          </ng-template>
        </ngx-datatable-column>

          <!-- Actions -->
<ngx-datatable-column name="{{ 'MENU.DASHBOARD.investor_actions' | translate }}" prop="actions" [flexGrow]="1" [sortable]="false">
  <ng-template ngx-datatable-cell-template let-row="row">
    <div class="d-flex align-items-center">
      <div ngbDropdown container="body" class="btn-group">
        <button
          ngbDropdownToggle
          type="button"
          class="btn btn-sm btn-icon dropdown-toggle hide-arrow"
          [id]="'dropdownActions_' + row.id"
        >
          <i data-feather="more-vertical"></i>
        </button>

        <div
          ngbDropdownMenu
          class="dropdown-menu dropdown-menu-right"
          [attr.aria-labelledby]="'dropdownActions_' + row.id"
        >

                       <!-- Edit Button -->
  <!-- <button
    class="dropdown-item text-primary w-100"
    ngbDropdownItem
    (click)="showTags(row.id)"
  >
    <i data-feather="eye" class="mr-50 mx-2"></i>
    {{ 'MENU.DASHBOARD.Show_Product_Tags' | translate }}
  </button> -->

     <!-- Edit Button -->
      <button
        class="dropdown-item w-100"
        ngbDropdownItem
        (click)="editPartners(row.id)"
      >
        <i data-feather="edit" class="mr-50 mx-2"></i>
         {{ 'MENU.DASHBOARD.investor_edit' | translate }}
      </button>

          <button
            class="dropdown-item text-danger w-100"
            ngbDropdownItem
  (click)="confirmDelete(row.id)"
          >
            <i data-feather="trash" class="mr-50 mx-2"></i>
                 {{ 'MENU.DASHBOARD.investor_delete' | translate }}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</ngx-datatable-column>


      </ngx-datatable>
       
      </section>
    </div>
  </div>
  